module.exports = "<scxml>\n  <state id=\"unplugged\">\n    <transition event=\"plug-in\" target=\"plugged-in\"/>\n  </state>\n  <state id=\"plugged-in\">\n    <state id=\"idle\">\n      <transition event=\"start\" target=\"cooking\"/>\n    </state>\n    <state id=\"cooking\">\n      <transition event=\"stop\" target=\"idle\"/>\n    </state>\n    <transition event=\"unplug\" target=\"unplugged\"/>\n  </state>\n</scxml>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/examples/microwave-example/microwave3.scxml
// module id = 892
// module chunks = 240162396545425